import { render, staticRenderFns } from "./homeGd.vue?vue&type=template&id=a46fa58a&"
import script from "./homeGd.vue?vue&type=script&lang=js&"
export * from "./homeGd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports